import api from "@/services/api/images";

const state = {
  isSaving: false,
  isSaved: false,
  isDialogOpen: false,
  message: "",
};

const getters = {
  saving: (state) => state.isSaving,
  saved: (state) => state.isSaved,
  dialog: (state) => state.isDialogOpen,
  message: (state) => state.message,
};

const actions = {
  open({ commit }) {
    commit("setMessage", "");
    commit("open");
  },
  close({ commit }) {
    commit("close");
  },
  async uploadImages({ commit, dispatch }, { photos, images }) {
    commit("saving", { isSaving: true });
    const payload = photos
      ? photos
      : (images || []).map((file) => ({
          file,
          name: "",
          imageNumber: "",
          whaleId: "",
          sightingNumber: "",
        }));
    try {
      const response = await api.uploadImages(payload);
      await commit("uploadComplete", {
        success: true,
        numCreated: response.data.numCreated,
      });
      dispatch("imageSearch/reload", {}, { root: true });
    } catch (e) {
      commit("uploadComplete", { success: false });
      if (e.response && e.response.data) {
        commit("setMessage", e.response.data.detail);
      } else {
        commit("setMessage", "Unexpected error while uploading images!");
      }
    }
  },
  setMessage({ commit }, message) {
    commit("setMessage", message);
  },
};

const mutations = {
  open(state) {
    state.isDialogOpen = true;
    state.isSaving = false;
    state.isSaved = false;
  },
  close(state) {
    state.item = {};
    state.isDialogOpen = false;
    state.isSaved = false;
    state.isSaving = false;
  },
  saving(state, { isSaving }) {
    state.isSaving = isSaving;
  },
  setMessage(state, message) {
    state.message = message;
    state.isSaving = false;
  },
  uploadComplete(state, { success, numCreated }) {
    if (success) {
      state.isSaved = true;
      state.message = `Successfully imported ${numCreated} images.`
    }
    state.isSaving = false;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
